// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__reFt8","notificationButton":"Notification_notificationButton__34Gfc"};